module.exports = __webpack_public_path__ + "static/media/arrow-right-tilted.a2560bf5.svg";